$output1-header-color:'#ADC5D6' !default;
$output1-title-color:'#CCCDD0' !default;
$output1-color:'#ADC5D6' !default;
$output1-background:'#111C27' !default;
$output1-divider-color:'#22303F' !default;
$output1-border:0 !default;

@mixin background {
  background: #{$output1-background};
  border:#{$output1-border} ;
}

@mixin content {
  .title {
    color: #{$output1-title-color};
  }
}

.output1-row {
  .output1-row-block {
    @include background;
    .text {
      color: #{$output1-color};
    }
    .grinder {
      color: #{$output1-color};
    }
    .content {
      .minimum {
        @include content;
      }
      .start-time {
        @include content;
      }
      .maximum {
        @include content;
      }
    }
    .divider {
      hr {
        border-top: 2px solid #{$output1-divider-color}
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/recipe/editor/output1/output1-theme.scss